import React from "react";
import { Modal } from "react-bootstrap";
import { imageUrl } from "../../actions/miscAction";
const loadingIcon = imageUrl("loading-icon.svg");
const DeleteModal = ({ message, show, handleClose, loading, handleDelete }) => {
  return (
    <Modal
      className="modal fade custom-modal-popup"
      show={show}
      onHide={() => handleClose()}
      dialogClassName="modal-dialog modal-dialog-centered modal-sm"
      backdropClassName="modal-delete-backdrop"
    >
      <div class="modal-body">
        <div class="modal-alert-box">
          <h4>Alert!</h4>
          <p>{message}</p>
        </div>
        <div class={loading ? "modal-action-btn load-msg" : "modal-action-btn"}>
          <a
            href="javascript:void(0)"
            class="btn btn-delete btn-md"
            onClick={(e) => {
              if (e) e.preventDefault();
              handleDelete();
            }}
          >
            {loading ? (
              <b class="btn-loader">
                <img src={loadingIcon} alt="loader" class="loader-img fa-spin" />
              </b>
            ) : (
              "Delete"
            )}
          </a>
          <a
            href="javascript:void(0)"
            class="btn btn-cancel"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={(e) => {
              console.log("I enan");
              handleClose();
            }}
          >
            Cancel
          </a>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteModal;
